import { useState } from 'react';
import Cookie from 'js-cookie';

import { DEFAULT_COUNTRY_CODE, STORAGE } from 'shared/enums/SitePreferences';

interface IUseLocation {
  selectedCountryCode: string;
  setSelectedCountryCode: (countryCode: string) => void;
}

export const useLocation = (): IUseLocation => {
  const countryCookie = Cookie.getJSON(STORAGE.COUNTRY);

  const [selectedCountryCode, setSelectedCountryCode] = useState(
    countryCookie || DEFAULT_COUNTRY_CODE,
  );

  return {
    selectedCountryCode,
    setSelectedCountryCode,
  };
};
